import classNames from 'classnames';
import { forwardRef } from 'react';

import { getMessageFromError } from 'my-core/error-utils';

import Typography from '@mui/material/Typography';

const rootCss = ({ constants, spacing }) => ({
  '&.rootFullPage': {
    padding: spacing(constants.APPBAR_HEIGHT_UNITS + 2, 2, 2),
  },
});

export default forwardRef(function ErrorMessage(props, ref) {
  const { className, error, fullPage, ...rest } = props;
  return (
    <Typography className={classNames(className, { rootFullPage: fullPage })} css={rootCss} {...rest} ref={ref}>
      {getMessageFromError(error)}
    </Typography>
  );
});
